import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Contributor from './Contributor';
import CallToActionCard from './CallToActionCard';

const ResultsContainer = styled('div')`
  grid-column: results / bleed;
  grid-row: results / bleed;
  justify-content: stretch;
  align-content: flex-start;
  display: flex;
  flex-wrap: wrap;
`;

const Results = ({ contributors, toggleModal, remainingSearches }) => {
  const contributorCards = contributors.map(contributor => {
    return <Contributor key={contributor.name} contributor={contributor} />;
  });

  const blurContributor = {
    name: 'Johnny Appleseed',
    avatar_url: 'https://cdn.macrumors.com/article-new/2019/07/jony_ive-200x200.jpg?retina',
    bio:
      'Sir Jonathan Paul "Jony" Ive, KBE, HonFREng, RDI is a British industrial designer who is the outgoing Chief Design Officer of Apple and the serving Chancellor of the Royal College of Art in London. ',
    portfolio_url: 'https://www.apple.com/leadership/jonathan-ive/'
  };

  const numBlurContributors = 8 - contributors.length;
  for (let i = 0; i < numBlurContributors; i += 1) {
    contributorCards.push(<Contributor key={i} contributor={blurContributor} blur />);
  }

  contributorCards.push(
    <CallToActionCard
      remainingSearches={remainingSearches}
      toggleModal={toggleModal}
      key="cta-card"
    />
  );

  return <ResultsContainer className="Results">{contributorCards}</ResultsContainer>;
};

Results.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      avatarUrl: PropTypes.string.isRequired,
      bio: PropTypes.string.isRequired,
      portfolioUrl: PropTypes.string.isRequired
    })
  ).isRequired,
  remainingSearches: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

export default Results;
